export let OrderKeys = {
  adminCount: 'adminCount',
  alphabeticalAscending: 'AZ',
  alphabeticalDescending: 'ZA',
  authoringEnabled: 'authoringEnabled',
  availability: 'availability',
  childProjectCount: 'childProjectCount',
  completedAt: 'completedAt',
  connectionTypeDisplayName: 'connectionTypeDisplayName',
  connectedWorkbooksCount: 'connectedWorkbooksCount',
  contentTypeOrder: 'contentTypeOrder',
  currentLoggedInUserCount: 'currentLoggedInUserCount',
  currentQueueTime: 'currentQueueTime',
  currentRunTime: 'currentRunTime',
  createdAt: 'createdAt',
  creatorName: 'creatorName',
  datasourceCount: 'datasourceCount',
  definition: 'definition', // definition of a remote refresh schedule, for Data Sync
  displayName: 'displayName',
  domainName: 'domainName',
  extractEncryptionMode: 'extractEncryptionMode',
  favoritesTotal: 'favoritesTotal',
  flowName: 'flowName',
  flowOutputStepName: 'flowOutputStepName',
  guestAccessEnabled: 'guestAccessEnabled',
  groupCount: 'groupCount',
  hasAlert: 'hasAlert',
  hasExtracts: 'hasExtracts',
  hitsTotal: 'hitsTotal',
  hitsLastTwoWeeksTotal: 'hitsLastTwoWeeksTotal',
  hitsLastOneMonthTotal: 'hitsLastOneMonthTotal',
  hitsLastThreeMonthsTotal: 'hitsLastThreeMonthsTotal',
  hitsLastTwelveMonthsTotal: 'hitsLastTwelveMonthsTotal',
  index: 'index',
  isCertified: 'isCertified',
  lastAccessedAt: 'lastAccessedAt', // used for GetDetailedRecents queries
  lastChecked: 'lastChecked',
  lastRefreshedAt: 'lastRefreshedAt',
  lastRunAt: 'lastRunAt',
  lastSentAt: 'lastSentAt',
  lastSignIn: 'lastSignIn',
  licenseLevel: 'subscriptionLicensingRole',
  jobId: 'jobId',
  jobRequestedTime: 'jobRequestedTime',
  maxSiteRole: 'maxSiteRole',
  metricsEnabled: 'metricsEnabled',
  metricValue: 'metricValue',
  metricViewName: 'metricViewName',
  metricUpdated: 'metricUpdated',
  minimumSiteRole: 'minimumSiteRole',
  name: 'name',
  notificationIntervalInMinutes: 'notificationIntervalInMinutes',
  numSheets: 'numSheets',
  numericAscending: 'least',
  numericDescending: 'most',
  ownerName: 'ownerName',
  parentName: 'parentName',
  position: 'position', // used for favorites queries
  priority: 'priority',
  projectName: 'projectName',
  publishedDataSourceName: 'publishedDataSourceName',
  refreshType: 'refreshType', // full or incremental remote refresh, for Data Sync
  relevance: 'relevancy',
  rowsProduced: 'rowsProduced',
  runNextAt: 'runNextAt',
  scheduleName: 'scheduleName',
  siteAdminsCanAddUsers: 'siteAdminsCanAddUsers',
  siteCount: 'siteCount',
  siteName: 'siteName',
  siteRole: 'siteRole',
  size: 'size',
  sheetImageEnabled: 'sheetImageEnabled',
  startedAt: 'startedAt',
  status: 'status',
  storageQuotaBytes: 'storageQuotaBytes',
  storageQuotaPercentUsed: 'storageQuotaPercentUsed',
  storageUsedBytes: 'storageUsedBytes',
  subject: 'subject',
  subscriptionsTotal: 'subscriptionsTotal',
  targetName: 'targetName',
  taskType: 'taskType',
  timeAscending: 'oldest',
  timeDescending: 'newest',
  title: 'title',
  type: 'type',
  updatedAt: 'updatedAt',
  urlName: 'urlName',
  userCount: 'userCount',
  userDisplayName: 'userName', // "displayName" property for the user associated with an item
  username: 'username', // "username" property of a user
  userQuota: 'userQuota',
  versionNumber: 'versionNumber',
  viewCount: 'viewCount',
  workbookCount: 'workbookCount',
  workbookName: 'workbookName'
};
